import { hasAcl, aclStatusOptions, aclReasonOptions, aclStatusLabel, resolveAclReason } from "./aclCodes";

// Codes the screens' logic keys on. Every label and list comes from the server (login, GET /acl/codes).
export const NONE = { code: "", text: "Select Status Code" };
export const SUCCESS = { code: "55" };
export const IN_PROGRESS = { code: "11" };
export const AWAITING_APPROVAL = { code: "33" };
export const APPROVED = { code: "22" };
export const NO_FURTHER_ACTION = { code: "99" };
export const NO_ACTION = { code: "00" };
export const PURCHASE = { code: "44" };
export const PURCHASE_IN_PROGRESS = { code: "66" };
export const PURCHASE_IN_COMPLETE = { code: "77" };
export const TP_Approve = { code: "105" };
export const TP_InProgress = { code: "108" };
export const TP_Success = { code: "111" };
export const TP_Client_Review = { code: "113" };
export const TP_No_Action = { code: "115" };
export const TP_No_Further_Action = { code: "117" };
export const CLIENT_REVIEW = { code: "88" };
export const SELF_RESOLVED = { code: "90" };
export const PURCHASE_INCOMPLETE_PRODUCT_NOT_AVAILABLE = { code: "101" };
export const PURCHASE_INCOMPLETE_SELLER_NOT_RESPONSIVE = { code: "102" };
export const CONTINUE_MONITORING = { code: "60" };

const codesOf = (...statuses) => statuses.map((status) => status.code);

const TP_CODES = codesOf(TP_Approve, TP_InProgress, TP_Success, TP_Client_Review, TP_No_Action, TP_No_Further_Action);
const PURCHASE_CODES = codesOf(PURCHASE, PURCHASE_IN_PROGRESS, PURCHASE_IN_COMPLETE, PURCHASE_INCOMPLETE_PRODUCT_NOT_AVAILABLE, PURCHASE_INCOMPLETE_SELLER_NOT_RESPONSIVE);

// the order screens have always listed the default statuses in; other codes follow in the order the server sends them
const STATUS_ORDER = ["55", "11", "33", "22", "99", "00", "88", "90", "60", "44", "66", "77", "101", "102", "105", "108", "111", "113", "115", "117"];

const statusRank = (code) => {
  const index = STATUS_ORDER.indexOf(code);
  return index === -1 ? STATUS_ORDER.length : index;
};

const byStatusOrder = (a, b) => statusRank(a.code) - statusRank(b.code);

// options: { platform, companyId, allCompanies }
const statuses = (options) => (hasAcl() ? aclStatusOptions(options).sort(byStatusOrder) : []);

const only = (codes, options) => statuses(options).filter((status) => codes.includes(status.code));

export const fetchInfrigementAllStatus = () => {
  return [NONE, ...statuses({ platform: "domain" }).filter((status) => !TP_CODES.includes(status.code) && !PURCHASE_CODES.includes(status.code))];
};

export const fetchInfrigementEcommerceStatus = () => {
  return [NONE, ...statuses({ platform: "e-commerce" })];
};

export const fetchTpStatus = () => only(TP_CODES, { platform: "e-commerce" });

export const isTpStatus = (code) => {
  const statusCode = ["77", "105", "108", "111", "113", "115", "117"];
  return statusCode.some((c) => c == code);
};

//code and text
export const fetchAllReasonCode = () => {
  return hasAcl() ? aclReasonOptions({ allCompanies: true }) : [];
};

export const getReasonCodeText = (code) => {
  return hasAcl() ? resolveAclReason(code, { allCompanies: true }) : code || "";
};

// Status choices for a screen: default codes plus the company's custom ones.
export const statusSelectOptions = (options, legacy) => {
  return hasAcl() ? [NONE, ...statuses(options)] : legacy();
};

// A reason key ("123") or text ("TM") to the text a record stores, or "" when it is not allowed.
export const resolveReasonCode = (value, options) => {
  return hasAcl() ? resolveAclReason(value, options) : "";
};

export const getInfrigementStatusText = (code) => aclStatusLabel(code);

// return all status related to purchase
export const getAllPurchaseStatusText = () => only(PURCHASE_CODES, { platform: "e-commerce" });
